import { useEffect, useState } from "react";
import { Plus, FileText, Search, Send, Loader2 } from "lucide-react";
import { api, API } from "../../lib/api";
import { toast } from "sonner";
import DocumentScannerBox from "../../components/DocumentScannerBox";

export default function Multe() {
  const [list, setList] = useState([]);
  const [pec, setPec] = useState([]);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [pecSearch, setPecSearch] = useState("");
  const [showAddPec, setShowAddPec] = useState(false);
  const [newPec, setNewPec] = useState({ ente: "", pec: "" });
  // --- AUTO-TARGA by data ---
  const [contractCandidates, setContractCandidates] = useState([]);
  const [lookupBusy, setLookupBusy] = useState(false);
  // --- PEC SEND modal ---
  const [pecSend, setPecSend] = useState(null); // multa selezionata
  const [pecForm, setPecForm] = useState({ destinatario: "", oggetto: "", corpo: "" });
  const [pecBusy, setPecBusy] = useState(false);
  const [pecLog, setPecLog] = useState([]);
  const [form, setForm] = useState({
    targa: "", numero_verbale: "", data_violazione: "", ente_verbalizzante: "",
    ente_pec: "", articolo_cds: "", importo: 0, note: "",
  });

  const load = async () => {
    const [m, p] = await Promise.all([api.get("/multe"), api.get("/pec-rubrica")]);
    setList(m.data); setPec(p.data);
  };
  useEffect(() => { load(); }, []);

  // === AUTO-TARGA: quando l'operatore inserisce la data della violazione, recupera i contratti attivi a quella data
  useEffect(() => {
    const d = form.data_violazione;
    if (!d || d.length < 10) { setContractCandidates([]); return; }
    let cancelled = false;
    setLookupBusy(true);
    api.get(`/contracts/by-date?date=${d}`).then((r) => {
      if (cancelled) return;
      const list = r.data || [];
      setContractCandidates(list);
      // Se c'è un solo contratto attivo a quella data e l'utente non ha ancora messo la targa, auto-applica
      if (list.length === 1 && !form.targa) {
        setForm((f) => ({ ...f, targa: (list[0].targa || "").toUpperCase() }));
        toast.success(`Targa auto-popolata: ${list[0].targa} (contratto ${list[0].numero})`);
      }
    }).catch(() => { if (!cancelled) setContractCandidates([]); })
      .finally(() => { if (!cancelled) setLookupBusy(false); });
    return () => { cancelled = true; };
  }, [form.data_violazione]); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/multe", { ...form, importo: +form.importo, targa: form.targa.toUpperCase() });
      toast.success("Multa registrata · PEC salvata in rubrica");
      setShow(false);
      setForm({ targa: "", numero_verbale: "", data_violazione: "", ente_verbalizzante: "", ente_pec: "", articolo_cds: "", importo: 0, note: "" });
      load();
    } catch (e) { toast.error("Errore"); }
  };

  const openRicorso = (id) => {
    fetch(`${API}/multe/${id}/ricorso`, { credentials: 'include' })
      .then((r) => r.blob()).then((b) => window.open(URL.createObjectURL(b), "_blank"));
  };

  const openPecSend = async (m) => {
    setPecSend(m);
    setPecForm({
      destinatario: m.ente_pec || "",
      oggetto: `Ricorso in autotutela — Verbale n. ${m.numero_verbale} del ${m.data_violazione}`,
      corpo: `Spett.le ${m.ente_verbalizzante || "Ente verbalizzante"},\n\ncon la presente si trasmette il ricorso in autotutela relativo al verbale in oggetto, contestato in capo alla società scrivente in qualità di proprietaria del veicolo targato ${m.targa}.\n\nSi chiede il reindirizzo del verbale al locatario del veicolo ai sensi degli artt. 196 e 201 C.d.S., come da documentazione allegata.\n\nDistinti saluti.`,
    });
    try {
      const r = await api.get(`/multe/${m.id}/pec-log`);
      setPecLog(r.data || []);
    } catch { setPecLog([]); }
  };

  const sendPec = async () => {
    if (!pecSend) return;
    if (!pecForm.destinatario || !pecForm.destinatario.includes("@")) {
      toast.error("Inserisci un destinatario PEC valido");
      return;
    }
    setPecBusy(true);
    try {
      const r = await api.post(`/multe/${pecSend.id}/pec-send`, pecForm);
      toast.success("PEC inviata correttamente ✓");
      setPecLog([r.data.log, ...pecLog]);
      load();
      setTimeout(() => setPecSend(null), 800);
    } catch (e) {
      toast.error("Errore invio PEC: " + (e?.response?.data?.detail || e.message));
    } finally { setPecBusy(false); }
  };

  const addPec = async (e) => {
    e.preventDefault();
    if (!newPec.ente || !newPec.pec) return;
    await api.post(`/pec-rubrica?ente=${encodeURIComponent(newPec.ente)}&pec=${encodeURIComponent(newPec.pec)}`);
    toast.success("PEC salvata in rubrica");
    setForm({ ...form, ente_verbalizzante: newPec.ente, ente_pec: newPec.pec });
    setNewPec({ ente: "", pec: "" });
    setShowAddPec(false);
    load();
  };

  const filteredPec = pec.filter((p) => {
    if (!pecSearch) return true;
    const s = pecSearch.toLowerCase();
    return p.ente?.toLowerCase().includes(s) || p.pec?.toLowerCase().includes(s);
  });

  const filtered = list.filter((m) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return [m.numero_verbale, m.targa, m.ente_verbalizzante].some((x) => x?.toLowerCase().includes(s));
  });

  return (
    <div className="space-y-6" data-testid="multe-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display text-3xl font-black uppercase tracking-tight">Multe / Verbali</h1>
          <p className="text-sm text-white/45 mt-1">{list.length} verbali · ricorso in autotutela auto-compilato</p>
        </div>
        <div className="flex gap-3">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
            <input data-testid="multe-search" placeholder="Cerca targa, verbale, ente…" value={search} onChange={(e) => setSearch(e.target.value)}
              className="bg-white/[0.03] border border-white/10 rounded-full pl-9 pr-4 py-2 text-sm focus:border-[#ff0033]/60 focus:outline-none w-72" />
          </div>
          <button data-testid="multa-add" onClick={() => setShow(true)} className="btn-neon px-5 py-2 rounded-full text-xs inline-flex items-center gap-2">
            <Plus size={14} /> Registra Multa
          </button>
        </div>
      </div>

      <div className="glass rounded-2xl overflow-x-auto -mx-3 sm:mx-0 px-3 sm:px-0">
        <table className="w-full min-w-[760px] text-sm">
          <thead className="bg-white/[0.03] text-[10px] uppercase tracking-widest text-white/40">
            <tr>
              <th className="text-left p-4">Verbale</th>
              <th className="text-left p-4">Targa</th>
              <th className="text-left p-4">Ente · PEC</th>
              <th className="p-4">Data</th>
              <th className="p-4 text-right">Importo</th>
              <th className="p-4">Contratto</th>
              <th className="p-4 text-center">Azioni</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {filtered.map((m) => (
              <tr key={m.id} className="hover:bg-white/[0.02]" data-testid={`multa-${m.numero_verbale}`}>
                <td className="p-4 font-mono text-xs">{m.numero_verbale}<div className="text-[10px] text-white/40">Art. {m.articolo_cds}</div></td>
                <td className="p-4 font-mono">{m.targa}</td>
                <td className="p-4">
                  <div className="text-sm">{m.ente_verbalizzante}</div>
                  <div className="text-[10px] text-white/40 font-mono truncate max-w-[280px]">{m.ente_pec || '—'}</div>
                </td>
                <td className="p-4 text-center font-mono text-xs">{m.data_violazione}</td>
                <td className="p-4 text-right font-display font-bold neon-text">€{m.importo}</td>
                <td className="p-4 text-center">
                  {m.contract_id ? (
                    <span className="text-[10px] uppercase tracking-wider px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">Associato</span>
                  ) : (
                    <span className="text-[10px] uppercase tracking-wider px-2 py-1 rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/30">No match</span>
                  )}
                </td>
                <td className="p-4 text-center">
                  <div className="inline-flex items-center gap-1.5">
                    <button title="Genera Ricorso PDF" onClick={() => openRicorso(m.id)} data-testid={`ricorso-${m.numero_verbale}`}
                      className="p-1.5 rounded-lg bg-white/[0.04] hover:bg-[#ff0033]/15 text-white/60 hover:text-[#ff0033] inline-flex items-center gap-1">
                      <FileText size={12} /> <span className="text-[10px]">Ricorso</span>
                    </button>
                    <button title="Invia PEC con allegato Ricorso" onClick={() => openPecSend(m)} data-testid={`pec-send-${m.numero_verbale}`}
                      className={`p-1.5 rounded-lg inline-flex items-center gap-1 ${m.pec_inviata ? 'bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25' : 'bg-white/[0.04] hover:bg-[#ff0033]/15 text-white/60 hover:text-[#ff0033]'}`}>
                      <Send size={12} /> <span className="text-[10px]">{m.pec_inviata ? 'PEC ✓' : 'PEC'}</span>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="7" className="p-10 text-center text-white/40">Nessuna multa registrata.</td></tr>}
          </tbody>
        </table>
      </div>

      {/* MULTA FORM */}
      {show && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-6" onClick={() => setShow(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="w-full max-w-2xl glass-strong rounded-3xl p-6 max-h-[92vh] overflow-auto" data-testid="multa-form">
            <div className="font-display text-2xl font-bold mb-5">Registra Multa / Verbale</div>

            {/* SCANNER AI VERBALE */}
            <div className="mb-5">
              <DocumentScannerBox context="multe"
                testIdPrefix="multa-scan"
                title="Scansione AI · Verbale"
                subtitle="→ Auto-compila Targa + Data + Importo"
                description="Carica foto o PDF del verbale di accertamento. L'AI estrae targa, ente verbalizzante, data violazione, numero verbale e importo. Compilazione manuale sotto come fallback."
                variant="compact"
                onResult={(payload) => {
                  const v = payload?.veicolo || {};
                  const doc = payload?.documento || {};
                  // Auto-applica i campi se l'AI li ha trovati
                  setForm((f) => ({
                    ...f,
                    targa: (v.targa || f.targa || "").toUpperCase(),
                    data_violazione: doc.data_emissione || doc.data_violazione || f.data_violazione,
                    numero_verbale: doc.numero || f.numero_verbale,
                    ente_verbalizzante: doc.ente_emissione || f.ente_verbalizzante,
                    importo: (typeof payload.importo === "number" ? payload.importo : f.importo) || f.importo,
                  }));
                }}
              />
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Targa</label>
                <input required value={form.targa} onChange={(e) => setForm({ ...form, targa: e.target.value.toUpperCase() })}
                  data-testid="multa-targa"
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm font-mono" />
                {contractCandidates.length > 1 && (
                  <div className="mt-2 max-h-32 overflow-auto rounded-lg border border-amber-500/30 bg-amber-500/5">
                    <div className="px-3 py-1 text-[10px] uppercase tracking-widest text-amber-300/80 sticky top-0 bg-[#1a0f00]">Più contratti attivi — clicca per associare</div>
                    {contractCandidates.map((c) => {
                      const nm = c.customer?.ragione_sociale || `${c.customer?.nome || ""} ${c.customer?.cognome || ""}`.trim() || "—";
                      const active = (form.targa || "").toUpperCase() === (c.targa || "").toUpperCase();
                      return (
                        <button key={c.id} type="button" data-testid={`multa-candidate-${c.numero}`}
                          onClick={() => setForm({ ...form, targa: (c.targa || "").toUpperCase() })}
                          className={`w-full text-left px-3 py-2 text-xs border-t border-white/5 hover:bg-amber-500/10 ${active ? "bg-amber-500/15" : ""}`}>
                          <div className="font-mono font-bold">{c.targa} · {c.numero}</div>
                          <div className="text-[10px] text-white/55">{nm} · {c.data_inizio} → {c.data_fine}</div>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Numero Verbale</label>
                <input required value={form.numero_verbale} onChange={(e) => setForm({ ...form, numero_verbale: e.target.value })}
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Data Violazione</label>
                <input required type="date" value={form.data_violazione} onChange={(e) => setForm({ ...form, data_violazione: e.target.value })}
                  data-testid="multa-data-violazione"
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm" />
                {form.data_violazione && (
                  <div className="mt-1 text-[10px] text-white/45">
                    {lookupBusy ? "Ricerca contratti attivi…" :
                      contractCandidates.length === 0 ? "Nessun contratto attivo a questa data" :
                      contractCandidates.length === 1 ? `1 contratto trovato → targa auto-impostata` :
                      `${contractCandidates.length} contratti attivi a questa data — scegli sotto`}
                  </div>
                )}
              </div>
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Art. CdS</label>
                <input value={form.articolo_cds} onChange={(e) => setForm({ ...form, articolo_cds: e.target.value })}
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm" placeholder="Es. 142" />
              </div>
              <div className="col-span-2">
                <div className="flex items-center justify-between mb-1">
                  <label className="text-[10px] uppercase tracking-widest text-white/40">Ente Verbalizzante (PEC)</label>
                  <button type="button" onClick={() => setShowAddPec(!showAddPec)} className="text-[10px] uppercase tracking-wider text-[#ff0033] hover:underline">
                    + Nuova PEC
                  </button>
                </div>
                <div className="relative">
                  <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
                  <input data-testid="pec-search" placeholder="Cerca nella rubrica…" value={pecSearch} onChange={(e) => setPecSearch(e.target.value)}
                    className="w-full bg-white/[0.03] border border-white/10 rounded-lg pl-8 pr-3 py-2 text-sm" />
                </div>
                <div className="mt-2 max-h-44 overflow-auto rounded-lg border border-white/5">
                  {filteredPec.slice(0, 50).map((p) => (
                    <button type="button" key={p.pec} onClick={() => setForm({ ...form, ente_verbalizzante: p.ente, ente_pec: p.pec })}
                      className={`w-full text-left px-3 py-2 text-xs hover:bg-white/[0.05] border-b border-white/5 ${form.ente_pec === p.pec ? "bg-[#ff0033]/10" : ""}`}>
                      <div className="font-medium">{p.ente}</div>
                      <div className="text-[10px] text-white/40 font-mono">{p.pec}</div>
                    </button>
                  ))}
                  {filteredPec.length === 0 && <div className="p-3 text-center text-xs text-white/40">Nessun risultato — aggiungila manualmente</div>}
                </div>
                {showAddPec && (
                  <div className="mt-2 p-3 rounded-lg bg-white/[0.03] border border-white/10">
                    <div className="text-[10px] uppercase tracking-widest text-white/40 mb-2">Aggiungi PEC alla rubrica</div>
                    <div className="grid grid-cols-[1fr_1fr_auto] gap-2">
                      <input placeholder="Ente" value={newPec.ente} onChange={(e) => setNewPec({ ...newPec, ente: e.target.value })}
                        className="bg-white/[0.03] border border-white/10 rounded px-2 py-1.5 text-sm" />
                      <input placeholder="pec@enti.it" value={newPec.pec} onChange={(e) => setNewPec({ ...newPec, pec: e.target.value })}
                        className="bg-white/[0.03] border border-white/10 rounded px-2 py-1.5 text-sm" />
                      <button type="button" onClick={addPec} className="btn-neon px-3 rounded text-xs">Salva</button>
                    </div>
                  </div>
                )}
              </div>
              {form.ente_pec && (
                <div className="col-span-2 px-3 py-2 rounded-lg bg-[#ff0033]/10 border border-[#ff0033]/30 text-xs">
                  <span className="text-white/40">Selezionato:</span> <b>{form.ente_verbalizzante}</b> <span className="text-white/60 font-mono">{form.ente_pec}</span>
                </div>
              )}
              <div className="col-span-2">
                <label className="text-[10px] uppercase tracking-widest text-white/40">Importo €</label>
                <input type="number" step="0.01" value={form.importo} onChange={(e) => setForm({ ...form, importo: e.target.value })}
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm" />
              </div>
            </div>
            <div className="flex gap-3 mt-5 justify-end">
              <button type="button" onClick={() => setShow(false)} className="px-5 py-2.5 rounded-full text-sm bg-white/[0.04] border border-white/10">Annulla</button>
              <button data-testid="multa-form-submit" type="submit" className="btn-neon px-6 py-2.5 rounded-full text-sm">Registra Multa</button>
            </div>
          </form>
        </div>
      )}
      {/* PEC SEND MODAL */}
      {pecSend && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-6" onClick={() => !pecBusy && setPecSend(null)}>
          <div onClick={(e) => e.stopPropagation()} className="w-full max-w-2xl glass-strong rounded-3xl p-6 max-h-[92vh] overflow-auto" data-testid="pec-send-modal">
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="font-display text-2xl font-bold">Invia PEC — Ricorso in autotutela</div>
                <div className="text-xs text-white/45 mt-1">
                  Verbale <span className="font-mono text-white/80">{pecSend.numero_verbale}</span> · Targa <span className="font-mono">{pecSend.targa}</span>
                </div>
                <div className="text-[10px] text-white/40 mt-1">Da: <span className="font-mono text-emerald-300">fabrirentmultiservice@pec.it</span></div>
              </div>
              <button onClick={() => !pecBusy && setPecSend(null)} className="text-white/40 hover:text-white">✕</button>
            </div>

            <div className="space-y-3">
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Destinatario PEC</label>
                <input value={pecForm.destinatario} onChange={(e) => setPecForm({ ...pecForm, destinatario: e.target.value })}
                  data-testid="pec-destinatario"
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm font-mono" placeholder="pec@ente.it" />
              </div>
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Oggetto</label>
                <input value={pecForm.oggetto} onChange={(e) => setPecForm({ ...pecForm, oggetto: e.target.value })}
                  data-testid="pec-oggetto"
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/40">Corpo messaggio</label>
                <textarea value={pecForm.corpo} onChange={(e) => setPecForm({ ...pecForm, corpo: e.target.value })}
                  data-testid="pec-corpo" rows={8}
                  className="mt-1 w-full bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2 text-sm font-mono" />
              </div>
              <div className="px-3 py-2 rounded-lg bg-emerald-500/10 border border-emerald-500/30 text-[11px] text-emerald-200">
                <b>Allegato automatico:</b> PDF Ricorso in autotutela pre-compilato con dati locatario, contratto e veicolo.
              </div>

              {pecLog.length > 0 && (
                <div className="mt-2">
                  <div className="text-[10px] uppercase tracking-widest text-white/40 mb-1">Storico invii ({pecLog.length})</div>
                  <div className="max-h-32 overflow-auto rounded-lg border border-white/5 divide-y divide-white/5">
                    {pecLog.map((l) => (
                      <div key={l.id} className="px-3 py-1.5 text-[11px] flex justify-between gap-3">
                        <span className="text-white/70 font-mono truncate">{l.destinatario}</span>
                        <span className="text-white/40 whitespace-nowrap">{l.ts?.slice(0,16).replace('T',' ')}</span>
                        <span className={l.esito === 'inviata' ? 'text-emerald-300' : 'text-rose-300'}>{l.esito}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="flex gap-3 mt-5 justify-end">
              <button type="button" disabled={pecBusy} onClick={() => setPecSend(null)} className="px-5 py-2.5 rounded-full text-sm bg-white/[0.04] border border-white/10 disabled:opacity-50">Annulla</button>
              <button data-testid="pec-send-confirm" disabled={pecBusy} onClick={sendPec} className="btn-neon px-6 py-2.5 rounded-full text-sm inline-flex items-center gap-2 disabled:opacity-60">
                {pecBusy ? <><Loader2 size={14} className="animate-spin" /> Invio in corso...</> : <><Send size={14} /> Invia PEC</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
